import { formValueSelector } from 'redux-form';
import { getTotalMarkup, getTotalPrice } from '../../../common/utils/price';
export const getMinPrice = (travelers = []) => travelers.reduce((minPrice, {
  price
}) => {
  if (!price || !Number.isFinite(price)) {
    return minPrice;
  }
  return minPrice ? Math.min(price, minPrice) : price;
}, null);
export const getPrice = (name, form) => state => {
  const selection = formValueSelector(form)(state, name);
  if (selection && selection !== null && selection !== void 0 && selection.value && Array.isArray(selection.value)) {
    return selection.value.reduce((totalPrice, {
      priceRaw = 0
    }) => totalPrice + priceRaw, 0);
  }
  return getTotalPrice(form, name)(state);
};
export const getMarkup = (name, form) => state => getTotalMarkup(form, name)(state);
//# sourceMappingURL=priceUtil.js.map